import React from "react";

import classes from "./ExportLayoutSelect.module.css";

// Covers the player when the selected version is a full-resolution export,
// which is offered for download only.
const DownloadOnlyNotice = () => (
    <div className={classes["DownloadOnlyNotice"]} role="status">
        <strong>Full-resolution export</strong>
        <span>
            It can't play here. Download it from the Downloads menu, or export a lower-resolution
            version to watch it in the browser.
        </span>
    </div>
);

export default DownloadOnlyNotice;
